import React from "react";

const SUPPORT_EMAIL = "it@lojenterprise.com";

const subject = encodeURIComponent("Ruoth Recipe Card - account deletion request");
const body = encodeURIComponent(
  "Please delete my Ruoth Recipe Card account and associated data.\n\n" +
    "Account email: \n" +
    "Delete everything (account + recipes), or only specific data (describe): \n"
);

export default function DeleteAccountScreen() {
  return (
    <main style={{ maxWidth: 720, margin: "0 auto", padding: "32px 20px", lineHeight: 1.6, fontFamily: "system-ui, sans-serif" }}>
      <h1>Delete your Ruoth Recipe Card account and data</h1>
      <p>
        This page explains how to request deletion of your Ruoth Recipe Card account
        (app: <code>com.ruoth.recipeapp</code>, developer: LOJ Enterprise) and the data linked to it.
      </p>

      <h2>How to request deletion</h2>
      <ol>
        <li>
          Email{" "}
          <a href={`mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`}>{SUPPORT_EMAIL}</a>{" "}
          from the email address registered to your account, with the subject
          &ldquo;Ruoth Recipe Card - account deletion request&rdquo;.
        </li>
        <li>
          State whether you want your <strong>whole account deleted</strong> or only{" "}
          <strong>specific data</strong> (for example recipes, uploaded images, or meal plans) removed.
        </li>
        <li>We confirm the request came from the account owner and complete it within 30 days.</li>
      </ol>

      <h2>What is deleted</h2>
      <ul>
        <li>Your account profile (email, name, login credentials).</li>
        <li>Your recipes, recipe versions, folders, templates, meal plans, and uploaded media.</li>
        <li>Parsed ingredient lines, comments and collaboration data you created.</li>
      </ul>

      <h2>What may be retained</h2>
      <p>
        Backups are overwritten on their normal rotation (up to 30 days after deletion). We may keep
        minimal records where required by law (for example billing or fraud-prevention records).
      </p>
    </main>
  );
}
